import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

import React from 'react';
import PropTypes from 'prop-types';
import { isStr, isFn, filterObj } from '@exah/utils';
import { DEFAULT_ELEMENT, DEFAULT_PROP_NAME } from './constants';
var ReactComponentPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, // Special react hocs: `forwardRef`, `memo`
PropTypes.shape({
  $$typeof: PropTypes.symbol.isRequired,
  render: PropTypes.func.isRequired
})]);

var filterProps = function filterProps(filter, tagName, props, isCustomFilter) {
  if (isCustomFilter === void 0) {
    isCustomFilter = false;
  }

  if (tagName == null && isCustomFilter === false) return props;
  return filterObj(function (propName) {
    return filter(tagName, propName);
  }, props);
};

var getDisplayName = function getDisplayName(comp) {
  return (isStr(comp) ? comp : comp.displayName) || 'Component';
};

export function createBaseFactory(createFilter) {
  return function createBase(defaultComp, options) {
    var _defaultProps, _propTypes;

    if (defaultComp === void 0) {
      defaultComp = DEFAULT_ELEMENT;
    }

    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$componentPro = _options.componentProp,
        componentProp = _options$componentPro === void 0 ? DEFAULT_PROP_NAME : _options$componentPro,
        compTagName = _options.tagName,
        whitelist = _options.whitelist,
        blacklist = _options.blacklist,
        customFilter = _options.isPropValid;
    var isCustomFilter = isFn(customFilter);
    var filter = isCustomFilter ? customFilter : createFilter({
      whitelist: whitelist,
      blacklist: blacklist
    });

    function BaseComponent(_ref, ref) {
      var Comp = _ref[componentProp],
          rest = _objectWithoutPropertiesLoose(_ref, [componentProp].map(_toPropertyKey));

      var tagName = isStr(Comp) ? Comp : compTagName;
      return React.createElement(Comp, _extends({
        ref: ref
      }, filterProps(filter, tagName, rest, isCustomFilter)));
    }

    return Object.assign(React.forwardRef(BaseComponent), {
      displayName: "Base(" + getDisplayName(defaultComp) + ")",
      defaultProps: (_defaultProps = {}, _defaultProps[componentProp] = defaultComp, _defaultProps),
      propTypes: (_propTypes = {}, _propTypes[componentProp] = ReactComponentPropType, _propTypes)
    });
  };
}